import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Header from '../../ui/components/header/Header';
import { ProductCategoriesShortcut } from '../productCategories/productCategoriesShortcut/ProductCategoriesShortcut';
import { ArrowUpDown, ChevronRight } from 'lucide-react';
import SubCategoryFilterForm from '../productCategories/filterForms/SubCategoryFilterForm';
import ProductCardSkeleton from '../../ui/components/skeletons/ProductCardSkeleton';
import ProductCard from '../../utils/ProductCard';
import { Pagination } from '../productCategories/Pagination';
import { fetchProductsBySearch } from '../../api/product-api';
import { useSelector } from 'react-redux';

function SearchProductResult() {
  let query = useSelector((state) => state.search.query);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const { category, sub_category } = useParams();
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get('q');

  // navigate back to homepage if no search query
  useEffect(() => {
    if (!query || !searchQuery) {
      navigate('/');
    }
  }, [query, searchQuery]);

  query = query || searchQuery;

  const { data, isLoading, error } = useQuery({
    queryKey: ['products-by-search', query, page],
    queryFn: () => fetchProductsBySearch(query, page),
    enabled: !!query,
  });

  const products = data?.data?.results?.products || [];
  const totalProducts = data?.data?.results?.total;
  const totalPages = data?.data?.results?.total_pages;

  return (
    <>
      <Header />
      <main className=" lg:mx-[60px] mb-20">
        {/* <div className="flex px-0 overflow-x-auto">
          <ProductCategoriesShortcut categories={categories} />
        </div> */}

        <section className="px-5 lg:mx-0">
          <div className="font-duplet flex space-x-1 items-center mt-4">
            <p
              className=" text-[#222224] text-sm cursor-pointer"
              onClick={() => navigate('/')}
            >
              SmallSmall
            </p>
            <ChevronRight size={11} className="text-[#6B6B6B]" />
            <p
              className="text-[#222224] text-sm cursor-pointer"
              onClick={() => navigate(-1)}
            >
              Search
            </p>
          </div>
          <div className="flex justify-between items-baseline">
            <header className="mt-8 mb-5 flex items-baseline space-x-2">
              <h1 className="text-[25px] font-semibold capitalize">{query}</h1>
              <p className="font-duplet text-xs text-[#6B6B6B] flex items-center space-x-1">
                <span>({totalProducts})</span>
                <span>{totalProducts === 1 ? 'item' : 'items found'}</span>
              </p>
            </header>
            <div
              className="flex md:hidden items-center cursor-pointer hover:cursor-pointer hover:shadow-[0px_4px_0px_rgba(0,0,0,0.2)] hover:translate-x-1 transition-all duration-300 ease-in-out"
              // onClick={handleSortProducts}
              role="button"
              aria-label="Sort products by subcategory"
            >
              <p className="font-semibold text-sm">Sort</p>
              <span>
                <ArrowUpDown size={18} />
              </span>
            </div>
          </div>
          <hr />
          {/* {!error && (
            <div className="flex items-center flex-wrap space-x-4">
              <div className="flex items-baseline space-x-3  mt-2 mb-4">
                <p className="w-fit">Filter</p>
                <>
                  <SubCategoryFilterForm products={data} />
                </>
              </div>
            </div>
          )} */}
          <hr className="mb-6" />{' '}
          {isLoading && (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
              {Array.from({ length: 10 }).map((_, index) => (
                <ProductCardSkeleton key={index} />
              ))}
            </div>
          )}
          {products?.length > 0 && (
            <section className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
              {products.map((product) => (
                <div key={product.id} className="mb-6">
                  <ProductCard product={product} />
                </div>
              ))}
            </section>
          )}
          {error && (
            <p className="text-center text-red-600 font-bold text-2xl   rounded-lg mt-10  w-full py-20 flex justify-center items-center">
              {error?.message}
            </p>
          )}
          {!products?.length && !isLoading && !error && (
            <p className="text-center text-white   rounded-lg mt-10 bg-gray-400 w-full py-20 flex justify-center items-center">
              {`No products found for ${query}.`}
            </p>
          )}
          <div className="flex justify-center md:justify-start">
            {products?.length !== 0 && (
              <Pagination
                page={page}
                setPage={setPage}
                totalPages={totalPages}
              />
            )}
          </div>
        </section>
      </main>
    </>
  );
}

export default SearchProductResult;
